import React, { useEffect } from "react"
import Link from "./link"
import CallToAction from "./call-to-action"
import OnClickLink from "./link-onclick"
import JobsSubscription from "./job-subscription"
import { graphql } from "gatsby"
import AOS from "aos"

import { HorizontalTeaserFieldsFragment } from "../../graphql-types"

export const query = graphql`
  fragment HorizontalTeaserFields on DatoCmsTeaser {
    componentId: key
    title
    headlineNode {
      childMarkdownRemark {
        html
      }
    }
    label
    blurbNode {
      childMarkdownRemark {
        html
      }
    }
    image {
      url(imgixParams: { w: "800" })
      alt
    }
    url
    urltext
    ctaType
  }
`

export interface HorizontalTeaserProps extends HorizontalTeaserFieldsFragment {
  variant?: (
    | "rightfull"
    | "extrawide"
    | "extrawidemobile"
    | "minus"
    | "light"
    | "right"
    | "left"
    | "largeheader"
    | "largeheadermobile"
    | "nospacing"
    | "textbottom"
    | "lesspadding"
    | "leftalign"
    | "changeorder"
    | "linkbutton"
    | "greybackground"
    | "no-bottom-margin-mobile"
    | "imagespecial"
    | "largerimagemobile"
    | "large"
    | "stickyimage"
  )[]
  extraClasses?: string
  dataaos?: string
  dataaosoffset?: string
  onClick?: () => void
}

const HorizontalTeaser: React.FC<HorizontalTeaserProps> = props => {
  const title =
    (props.headlineNode &&
      props.headlineNode.childMarkdownRemark &&
      props.headlineNode.childMarkdownRemark.html) ||
    props.title
  const label = props.label || ""
  const blurb =
    (props.blurbNode &&
      props.blurbNode &&
      props.blurbNode.childMarkdownRemark &&
      props.blurbNode.childMarkdownRemark.html) ||
    ""
  const url = props.url || ""
  const urltext = props.urltext || ""

  const imgSrc = props.image && props.image.url
  const imgAlt = (props.image && props.image.alt) || ""
  const ctatype = props.ctaType || "text"

  useEffect(() => {
    AOS.init()
    AOS.refresh()
  })

  const classNames = ["c-horizontal-teaser"]
  if (props.variant) {
    props.variant.forEach(variant => {
      classNames.push(`-${variant}`)
    })
  }
  if (props.extraClasses) {
    classNames.push(props.extraClasses)
  }

  return (
    <section
      id={props.componentId}
      className={classNames.join(" ")}
      style={{
        backgroundImage: `url()`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="o-wrapper u-flex u-flex-between u-flex-wrap u-vertical-center o-row">
        <div
          className="c-horizontal-teaser__img-container"
          data-aos={props.dataaos}
          data-aos-offset={props.dataaosoffset}
          data-aos-delay="100"
        >
          <img className="c-horizontal-teaser__img" src={imgSrc} alt={imgAlt} />
        </div>
        <div
          className="c-horizontal-teaser__content-container u-relative"
          data-aos={props.dataaos}
          data-aos-offset={props.dataaosoffset}
          data-aos-delay="100"
        >
          <span className="c-horizontal-teaser__label">{label}</span>
          <h2
            className="c-horizontal-teaser__heading c-heading--c"
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
          <div className="c-horizontal-teaser__img-container-small">
            <img
              className="c-horizontal-teaser__img -small"
              src={imgSrc}
              alt={imgAlt}
            />
          </div>
          <div className="c-horizontal-teaser__content-text">
            <div dangerouslySetInnerHTML={{ __html: blurb }} />
            {props.onClick && urltext ? (
              <OnClickLink onClick={props.onClick}>{urltext}</OnClickLink>
            ) : (
              url &&
              urltext && (
                <>
                  {ctatype === "text" && <Link url={url}>{urltext}</Link>}
                  {ctatype === "button" && (
                    <CallToAction url={url} color={"green"}>
                      {urltext}
                    </CallToAction>
                  )}
                </>
              )
            )}
            {ctatype === "job" && <JobsSubscription showFilters={true} />}
          </div>
        </div>
      </div>
    </section>
  )
}
export default HorizontalTeaser
